module.exports = __webpack_public_path__ + "static/videoEN_1-57dbf7950de7eda56e58011804e0249e.mp4";